/* Shared resolver for document permalinks on docs.ballistol.co.uk.
   Used by the Technical Data Library section and the product-page
   document downloads. Exposes window.BallistolDocs. */
(function () {
  const DOCS_BASE = 'https://docs.ballistol.co.uk/';
  const compactText = s => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');

  // Each rule: [groups, sds filename]. A rule matches when every group has at
  // least one term found in the compacted product title. First match wins, so
  // specific rules (e.g. "guncer spray") must come before generic ones ("guncer").
  const SDS_RULES = [
    [[['guncer'], ['grease', 'fett']], 'guncer-keramik-waffenfett-v3.0-englisch.pdf'],
    [[['guncer'], ['spray']], 'guncer-keramik-waffen-l-spray-v8.0-eng-lisch.pdf'],
    [[['guncer']], 'guncer-keramik-waffen-l-fl-ssig-v4.0-englisch.pdf'],
    [[['gunex'], ['spray']], 'gunex-mil-spray-v2.0-englisch.pdf'],
    [[['gunex']], 'gunex-mil-fl-ssig-v2.0-englisch.pdf'],
    [[['gunpart', 'waffenteile']], 'waffenteilereiniger-spray-v5.0-englisch.pdf'],
    [[['airsoft']], 'airsoft-gas-v9.1-englisch.pdf'],
    [[['sting', 'stichfrei'], ['tropical']], 'stichfrei-tropical-v2.0-englisch.pdf'],
    [[['sting', 'stichfrei'], ['animal']], 'stichfrei-animal-v7.0-englisch.pdf'],
    [[['sting', 'stichfrei'], ['kids', 'family']], 'stichfrei-lotion-kids-family-v4.0-englisch.pdf'],
    [[['sting', 'stichfrei'], ['tick', 'zecke']], 'stichfrei-zecke-v4.0-englisch.pdf'],
    [[['sting', 'stichfrei']], 'stichfrei-classic-v4.0-englisch.pdf'],
    [[['balsin']], 'balsin-schaft-l-sds-english.pdf'],
    [[['bikeclean']], 'bike-clean-sds-english.pdf'],
    [[['bikecer']], 'bike-cer-sds-english.pdf'],
    [[['degreaser']], 'cold-degreaser-sds-english.pdf'],
    [[['glassclean', 'glasclean', 'glasreiniger']], 'glas-reiniger-v3.1-englisch.pdf'],
    [[['h1']], 'ballistol-h1-spray-englisch.pdf'],
    [[['homeremedy', 'neoballistol']], 'home-remedy-sds-english.pdf'],
    [[['ptfe', 'teflon']], 'ballistol-ptfe-sds-english.pdf'],
    [[['pluvonin', 'impregnat', 'imprgnier']], 'impr-gnier-spray-v10.1-englisch.pdf'],
    [[['quickblue', 'schnellbr']], 'schnellbr-nierung-v6.0-englisch.pdf'],
    [[['resin']], 'harzl-ser-v5.0-englisch.pdf'],
    [[['robla']], 'robla-solo-mil-v3.0-englisch.pdf'],
    [[['silencer', 'schalld']], 'schalld-mpferreiniger-v3.0-englisch.pdf'],
    [[['silicon', 'silikon']], 'silikon-l-v6.0-englisch.pdf'],
    [[['universalclean', 'universalreiniger']], 'universal-reiniger-v3.1-englisch.pdf'],
    [[['universal', 'ballistol'], ['liquid']], 'universal-l-fl-ssig-v10.1-englisch.pd-f.pdf'],
    [[['universaloil', 'ballistolspray']], 'universal-oil-sds-english.pdf'],
    [[['vaseline']], 'vaseline-grease-sds-english.pdf'],
    [[['animal']], 'ballistol-animal-v5.0-englisch.pdf']
  ];

  function resolveSds(title) {
    const t = compactText(title);
    const hit = SDS_RULES.find(rule => rule[0].every(group => group.some(term => t.includes(term))));
    return hit ? DOCS_BASE + 'sds/' + hit[1] : null;
  }

  function resolveFlyer(title, categories) {
    const t = compactText(title);
    const c = compactText(categories);
    if (t.includes('sting') || t.includes('stichfrei')) return DOCS_BASE + 'product-flyers/sting-free.pdf';
    if (t.includes('bike') || c.includes('bike')) return DOCS_BASE + 'product-flyers/bicycle-care.pdf';
    if (t.includes('animal') || c.includes('animalcare')) return DOCS_BASE + 'product-flyers/animal-care.pdf';
    if (t.includes('universaloil') || t.includes('ballistolspray') || c.includes('universaloil')) return DOCS_BASE + 'product-flyers/universal-oil.pdf';
    if (c.includes('weaponcare') || c.includes('weaponaccessories') || c.includes('guncare')) return DOCS_BASE + 'product-flyers/gun-care.pdf';
    if (c.includes('peoplecare')) return DOCS_BASE + 'product-flyers/people-care.pdf';
    if (t.includes('cleaner') || c.includes('cleaner')) return DOCS_BASE + 'product-flyers/cleaner.pdf';
    return DOCS_BASE + 'catalogues/main-catalogue.pdf';
  }

  window.BallistolDocs = { DOCS_BASE, resolveSds, resolveFlyer };

  // Product page: fill in the document download links rendered by
  // sections/main-product.liquid (.product-documents containers).
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-documents').forEach(box => {
      const title = box.getAttribute('data-product-title');
      const categories = box.getAttribute('data-categories');

      const sdsLink = box.querySelector('.product-doc-sds');
      const sdsUrl = resolveSds(title);
      if (sdsLink) {
        if (sdsUrl) {
          sdsLink.href = sdsUrl;
          sdsLink.hidden = false;
        } else {
          sdsLink.remove();
        }
      }

      const flyerLink = box.querySelector('.product-doc-flyer');
      if (flyerLink) {
        flyerLink.href = resolveFlyer(title, categories);
        flyerLink.hidden = false;
      }

      const note = box.querySelector('.product-doc-none');
      if (note) {
        if (sdsUrl) note.remove();
        else note.hidden = false;
      }
    });
  });
})();
